import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApi } from '../../services/ApiServices.tsx'; // Servicio para hacer las solicitudes a la API
import { Ingrediente, Receta } from '../../interfaces/RecetaDetalle.interface.ts';
import Header from '../../components/Header.tsx';
import Footer from '../../components/Footer.tsx';
import Loader from '../../components/Loader.jsx';
import Grid2 from '@mui/material/Grid2/Grid2';
import './RecetaDetalle.css';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import DynamicCarousel from '../../components/DynamicCarousel.tsx';
import { useAuth } from '../../components/Auth/AuthContext.tsx';
import LoginModal from '../../components/LoginModal/LoginModal.tsx';
const checkedIcon = require('../../assets/img/checked.png'); // Ruta de la imagen de la palomita
const uncheckedIcon = require('../../assets/img/unchecked.png'); // Ruta de la imagen del círculo gris
const playImage = require('../../assets/img/play-image.png'); // Ruta de la imagen del play
const herdezLogo = require('../../assets/img/herdez-logo.png');

function RecetaDetalle() {
  const { ApiRequest } = useApi();
  const { user } = useAuth();

  const navigate = useNavigate(); // Obtiene la función de navegación
  const { id } = useParams(); // Obtener el ID de la receta desde la URL
  const location = useLocation();
  const { timeOfDay } = location.state || {}; // Accede a timeOfDay desde el estado
  const [recipe, setRecipe] = useState<Receta | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('ingredientes'); // Estado para la pestaña activa
  const [selectedIngredients, setSelectedIngredients] = useState({});
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [usedProducts, setUsedProducts] = useState<Ingrediente[] | null>(null); // Estado para productos usados
  const [isFavorite, setIsFavorite] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const [imgSources, setImgSources] = useState({});

  const handleImageClick = () => {
    setIsVideoPlaying(true);
  };

  const toggleIngredient = (ingredientId) => {
    setSelectedIngredients((prev) => ({
      ...prev,
      [ingredientId]: !prev[ingredientId], // Alterna el estado de selección
    }));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab); // Cambia la pestaña activa
  };
  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchRecipeDetail = async () => {
      try {
        const data = await ApiRequest(`api/Receta/${id}`); // Hacer la solicitud usando el ID
        console.log('receta', data);
        setUsedProducts(null);
        if (data.error) {
          alert(data.error);
          return;
        }
        setRecipe(data);
        await getFavorites();
      } catch (error) {
        console.error('Error fetching recipe details:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecipeDetail();
  }, [ApiRequest, id]);

  useEffect(() => {
    if (recipe) {
      identifyUsedProducts(recipe.ingredientes);
    }
  }, [recipe]);

  // Función para identificar productos usados
  const identifyUsedProducts = (ingredientes) => {
    const foundProducts = ingredientes.filter((ingrediente) => ingrediente.esProducto);
    setUsedProducts(foundProducts);
    const initialImgSources = {};
    foundProducts.forEach(producto => {
      initialImgSources[producto.id] = producto.imagen; // Suponiendo que cada producto tiene un ID único
    });
    setImgSources(initialImgSources);
  };

  const handleImageError = (id) => {
    setImgSources((prev) => ({
      ...prev,
      [id]: herdezLogo // Cambia a la imagen por defecto si hay un error
    }));
  };

  async function getRecetasPorTipo(section: String): Promise<any> {
    try {
      const body = JSON.stringify({ tipo: section });
      const data = await ApiRequest('api/Receta/MasRecientesPorTipo', 'POST', body);

      if (data && Array.isArray(data) && data.length > 0) {
        return data; // Devuelve los datos para que los maneje el componente hijo
      } else {
        console.warn('No se recibieron datos válidos');
        return [];
      }

    } catch (error) {
      console.error('Error fetching recetas:', error);
      return [];
    }
  }

  const goToRecetas = (event) => {
    navigate(`/Recetas`);
  };

  const handleOpenPDF = async () => {
    try {
      //const baseURL = process.env.REACT_APP_API_URL;
      const baseURL = window.REACT_APP_API_URL || "https://hoytoca2025-recipe-service.prd.cloudherdez.com";
      // const apikey = process.env.REACT_APP_API_KEY;
      const apikey = window.API_KEY || "HoyToca-Secret-2025~Di56m1-6BZWu6e+h>C";


      fetch(`${baseURL}/api/Receta/DescargarRecetaPdf?receta=${id}`, {
        method: 'GET',
        headers: {
          'Origin': window.location.origin,
          'x-api-key': apikey
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al descargar el PDF');
          }
          return response.blob();
        })
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank"); // Abre el PDF en nueva pestaña
        })
        .catch(error => {
          console.error('Error al descargar el PDF:', error);
        });


    } catch (error) {
      console.error("Error al abrir el PDF:", error);
    }
  };

  const handleShareURL = async () => {
    try {
      const currentUrl = window.location.href;
      if (navigator.share) {
        await navigator.share({
          title: 'Compartir Receta',
          text: 'Aquí tienes una receta para revisar:',
          url: currentUrl
        });
      } else {
        await navigator.clipboard.writeText(currentUrl);
        alert('Enlace copiado al portapapeles');
      }
    } catch (error) {
      console.error('Error al compartir la receta:', error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const getFavorites = async () => {
    try {

      setIsFavorite(false);
      const url = `api/Receta/ListasRecetasFavoritas?email=${user?.email ?? ""}`;
      const data = await ApiRequest(url, 'GET');

      // Verificar si el ID actual está en la lista de favoritos
      const isFavorite = data.some(favorite => favorite.id === id);

      if (isFavorite) {
        setIsFavorite(true);
        console.log("El elemento es un favorito");
        // Aquí puedes realizar alguna acción adicional si es favorito
      } else {
        setIsFavorite(false);
        console.log("El elemento no es un favorito");
      }

      return isFavorite;
    } catch (error) {
      console.error('Error fetching recetas:', error);
      return false; // En caso de error, asumimos que no es favorito
    }
  };
  const handleToggleFavorite = async () => {
    try {
      if (user == null) {
        handleLoginClick();
      } else {
        const body = JSON.stringify({ Email: user?.email ?? "", RecetaId: id });
        const url = !isFavorite ? 'api/Receta/AgregaFavorito' : 'api/Receta/EliminarRecetaFavorita';
        await ApiRequest(url, !isFavorite ? 'POST' : 'DELETE', body);

        getFavorites();
      }
    } catch (error) {
      console.error('Error fetching recetas:', error);
      return [];
    }
  }

  const handleLoginClick = () => {
    setLoginOpen(true);
  };
  const handleCloseLogin = () => {
    setLoginOpen(false);
  };

  return (
    <Grid2>
      <Header />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {recipe && (
            <Grid2 container spacing={1} className='container-receta-detalle'>
              <Grid2 size={{ md: 12, lg: 6 }}>
                <Grid2 size={12}><h1 className='titulo-receta-detalle'>{recipe.nombre}</h1></Grid2>
                {recipe.urlVideo ? (
                  <Grid2 size={12}
                    className={isVideoPlaying ? 'imagen-receta-detalle-video' : 'imagen-receta-detalle'}
                    style={{ backgroundImage: isVideoPlaying ? '' : `url(${recipe.urlImagen})` }}
                    onClick={handleImageClick}>
                    {/* Mostrar el video si se está reproduciendo, de lo contrario mostrar la imagen */}
                    {isVideoPlaying && recipe.urlVideo ? (
                      <video
                        src={recipe.urlVideo}
                        controls
                        autoPlay
                        className="video-receta"
                        style={{ width: '100%' }}
                      />
                    ) : (
                      <img src={playImage} alt="Reproducir" className="imagen-receta" />
                    )}
                  </Grid2>
                ) : (
                  <Grid2 size={12} className={'imagen-receta-detalle-video'} style={{ backgroundImage: `url(${recipe.urlImagen})` }} />
                )}

                <Grid2
                  size={12}
                  className='footer-video-receta-detalle'
                  container
                  justifyContent="space-between" // Distribuye los elementos en el contenedor
                  alignItems="center" // Alinea los elementos verticalmente en el centro
                >
                  <Grid2 size={5}>
                    <Typography><strong>Porciones:</strong> {recipe.porciones}</Typography>
                  </Grid2>
                  <Grid2 size={4}>
                    <Typography><strong>Dificultad:</strong> {recipe.tipoCocinero}</Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Typography><strong>Calificación:</strong> {recipe.porciones}</Typography> {/* Asegúrate de que 'calificacion' esté definido en recipe */}
                  </Grid2>
                </Grid2>
                {/* Contenido que cambia basado en la pestaña activa */}
              </Grid2>

              <Grid2 size={{ md: 12, lg: 6 }}>
                <Grid2 size={12}>
                  <Button className={activeTab === 'ingredientes' ? 'tab-seleccionado' : 'tab-no-seleccionado'}
                    onClick={() => handleTabChange('ingredientes')}
                  >
                    Ingredientes
                  </Button>
                  <Button className={activeTab === 'procedimiento' ? 'tab-seleccionado' : 'tab-no-seleccionado'}
                    onClick={() => handleTabChange('procedimiento')}
                  >
                    Procedimiento
                  </Button>
                  {recipe.informacionNutrimental && recipe.informacionNutrimental.length > 0 &&
                    <Button className={activeTab === 'informacion' ? 'tab-seleccionado' : 'tab-no-seleccionado'}
                      onClick={() => handleTabChange('informacion')}
                    >
                      Información nutricional
                    </Button>
                  }
                </Grid2>
                <Grid2 size={12} className='container-ingredients-receta-detalle'>
                  <Grid2 size={12} className='sub-container-ingredients-receta-detalle'>
                    {activeTab === 'ingredientes' && (
                      <>
                        <Typography>
                          *Recuerda tener todos tus ingredientes listos y a la mano  para facilitar la elaboración de tu receta
                        </Typography>

                        {recipe.ingredientes.map((ingrediente) => (
                          <Grid2
                            key={ingrediente.id} // Asegúrate de que cada ingrediente tenga un ID único
                            className="ingredient-item"
                            onClick={() => toggleIngredient(ingrediente.id)} // Maneja el clic
                          >
                            <Grid2 size={1} className="checkbox-container">
                              <img
                                src={selectedIngredients[ingrediente.id] ? checkedIcon : uncheckedIcon}
                                alt=""
                                style={{ width: '20px', height: '20px' }} // Ajusta el tamaño según lo necesario
                              />
                            </Grid2>
                            {ingrediente.esProducto ? (
                              <Typography variant="h6" fontWeight="bold">
                              {ingrediente.cantidad?.trim()
                                ? `${ingrediente.cantidad} de ${ingrediente.nombre} ${ingrediente.instrucciones ?? ''}`
                                : `${ingrediente.nombre} ${ingrediente.instrucciones ?? ''}`
                              }
                            </Typography>
                          ) : (
                            <Typography variant="h6">
                              {ingrediente.cantidad?.trim()
                                ? `${ingrediente.cantidad} de ${ingrediente.nombre} ${ingrediente.instrucciones ?? ''}`
                                : `${ingrediente.nombre} ${ingrediente.instrucciones ?? ''}`
                              }
                            </Typography>
                            )}
                          </Grid2>
                        ))}
                      </>
                    )}
                    {activeTab === 'procedimiento' && (
                      <>
                        {recipe.procedimientos
                          .slice() // copia para no mutar
                          .sort((a, b) => a.noPaso - b.noPaso)
                          .map((paso) => (
                            <Grid2
                              key={paso.noPaso}
                              className="ingredient-item"
                              onClick={() => toggleIngredient(paso.noPaso)}
                            >
                              {/* Checkbox igual que en ingredientes */}
                              <Grid2 size={1} className="checkbox-container">
                                <img
                                  src={selectedIngredients[paso.noPaso] ? checkedIcon : uncheckedIcon}
                                  alt=""
                                  style={{ width: 20, height: 20 }}
                                />
                              </Grid2>

                              {/* Texto igual al de ingredientes */}
                              <Typography
                                variant="h6"
                                color={paso.esTip ? 'text.secondary' : 'text.primary'}
                              >
                                {paso.esTip && (
                                  <em style={{ marginLeft: 8 }}>
                                    Es tip:{'\u00A0\u00A0\u00A0'}
                                  </em>
                                )}
                                {paso.descripcion}

                              </Typography>
                            </Grid2>
                          ))
                        }
                      </>
                    )}


                    {activeTab === 'informacion' && (
                      <>
                        <TableContainer component={Paper}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>Nutriente</TableCell>
                                <TableCell align="right">Total en Receta</TableCell>
                                <TableCell align="right">Por Porción</TableCell>
                                <TableCell align="right">% IDR</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {recipe.informacionNutrimental.map((info) => (
                                <TableRow key={info.nutriente}>
                                  <TableCell>{info.nutriente}</TableCell>
                                  <TableCell align="right">{info.totalReceta}</TableCell>
                                  <TableCell align="right">{info.porPorcion}</TableCell>
                                  <TableCell align="right">{info.idr}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Typography >{recipe.notaIdr}</Typography>
                      </>
                    )}
                  </Grid2>
                  {/* Contenedor para los botones */}
                  <Grid2 className="buttons-row">
                    {/* Botones de la izquierda */}
                    <Grid2 className="left-buttons">
                      <button className="action-button-time"><span className="material-icons">schedule</span> {recipe.tiempoPreparacion} min</button>
                      {recipe.urlVideo &&
                        <button className="action-button-start" onClick={handleImageClick}>Comenzar</button>
                      }
                    </Grid2>

                    {/* Botones de la derecha */}
                    <Grid2 className="right-buttons">
                      <button onClick={handleToggleFavorite} className="action-button-receta-noborder">
                        <span className="material-icons">{isFavorite ? "favorite" : "favorite_border"}</span>
                      </button>
                      <button onClick={handleOpenPDF} className="action-button"><span className="material-icons">system_update_alt</span></button>
                      <button onClick={handleShareURL} className="action-button"><span className="material-icons">share</span></button>
                      <button onClick={handlePrint} className="action-button"><span className="material-icons">print</span></button>
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>


              <Grid2 size={12} className='productos-usados-container'>
                <Typography className='productos-usados-title'>Que productos se usaron</Typography>
                <Typography className='productos-usados-subtitle'>Conoce los productos de la familia Herdez que se usaron en esta receta</Typography>
                <Grid2 className='productos-usados-list'>
                  {usedProducts && usedProducts.length > 0 ? (
                    usedProducts.map((producto, index) => (
                      <Grid2
                        key={index}
                        className={`producto-item ${index === Math.floor(usedProducts.length / 2) ? 'producto-centro' : ''}`}
                      >
                        <img
                          src={imgSources[producto.id]} // Usar la fuente de imagen del estado
                          alt={producto.nombre}
                          className='producto-imagen'
                          onError={() => handleImageError(producto.id)} // Maneja el error
                        />
                        <Typography
                          variant="subtitle1"
                          className={`producto-nombre ${index === Math.floor(usedProducts.length / 2) ? 'nombre-centro' : ''}`}
                        >
                          {producto.nombre}
                        </Typography>
                      </Grid2>
                    ))
                  ) : (
                    <Typography variant="body2" className='productos-usados-placeholder'>
                      No se usaron productos de la familia Herdez en esta receta.
                    </Typography>
                  )}

                </Grid2>
                {recipe.urlCompra?.trim() !== '' && (
                  <button
                    className="boton-comprar"
                    onClick={() => window.open(recipe.urlCompra, '_blank')}
                  >
                    Comprar
                  </button>
                )}

              </Grid2>

              {timeOfDay &&
                <>
                  <Grid2 size={12} className='mas-recetas-container'>
                    <Typography className='mas-recetas-title'>Más recetas</Typography>
                    <Typography className='mas-recetas-subtitle'>Descubre Más recetas para esta hora del día </Typography>
                  </Grid2>
                  <Grid2 size={12} key={timeOfDay.nombre}>
                    <DynamicCarousel
                      section={timeOfDay}
                      onLoadItems={() => getRecetasPorTipo(timeOfDay.nombre)} // Llama a la función cuando sea necesario
                      iconoCentrado={true} />
                  </Grid2>
                  <Grid2 size={12} key={timeOfDay.nombre} className='productos-usados-container'>
                    <button className='boton-ver-recetas' onClick={goToRecetas}>Ver todas las recetas</button>
                  </Grid2>
                </>
              }
            </Grid2>
          )}
        </>
      )}
      <LoginModal open={loginOpen} onClose={handleCloseLogin} />
      <Footer />
    </Grid2>
  );
}

export default RecetaDetalle;
